import { render, staticRenderFns } from "./hydrology-wen-dj.vue?vue&type=template&id=33d1a8b8&"
import script from "./hydrology-wen-dj.vue?vue&type=script&lang=js&"
export * from "./hydrology-wen-dj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports